<template>
  <div class="border border-slate-200 rounded-lg overflow-hidden">
    <div class="bg-slate-50 border-b border-slate-200 py-3 px-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-1.5">
          <Icon
            v-if="iconName"
            :name="iconName"
            size="1rem"
            class="text-slate-900"
          />
          <p
            class="text-sm font-medium text-slate-900 leading-none normal-case"
          >
            {{ title }}
          </p>
          <span
            v-if="hasBadge"
            class="bg-success-100 text-success-700 text-xxs font-medium px-2.5 py-0.5 rounded-full uppercase ml-1"
          >
            {{ badgeText }}
          </span>
        </div>
        <ToggleSwitch
          v-if="hasToggle"
          :switch-value="Boolean(toggleValue)"
          @switch-clicked="emit('toggleCategory')"
        />
      </div>
    </div>
    <div
      class="bg-white border-b border-slate-200 py-4 px-6 font-medium text-sm text-slate-600 leading-5 normal-case"
    >
      {{ description }}
    </div>
    <table class="w-full text-left border-collapse">
      <thead>
        <tr class="bg-slate-50 border-b border-slate-200">
          <th
            class="py-2.5 px-6 text-xs font-normal text-slate-600 w-1/4 tracking-normal normal-case"
          >
            {{ nameLabel }}
          </th>
          <th
            class="py-2.5 px-6 text-xs font-normal text-slate-600 w-1/4 tracking-normal normal-case"
          >
            {{ providerLabel }}
          </th>
          <th
            class="py-2.5 px-6 text-xs font-normal text-slate-600 w-2/4 tracking-normal normal-case"
          >
            {{ purposeLabel }}
          </th>
        </tr>
      </thead>
      <slot name="category-details" />
    </table>
  </div>
</template>
<script setup lang="ts">
import ToggleSwitch from "~/components/shared/toggle-switch/ToggleSwitch.vue";
const {
  hasBadge = false,
  badgeText = "",
  hasToggle = false,
  toggleValue = false,
} = defineProps<{
  title: string;
  description: string;
  nameLabel: string;
  providerLabel: string;
  purposeLabel: string;
  iconName?: string;
  hasBadge?: boolean;
  badgeText?: string;
  hasToggle?: boolean;
  toggleValue?: boolean;
}>();
const emit = defineEmits<{
  toggleCategory: [];
}>();
</script>
<style scoped>
th {
  @apply border-0;
  position: initial !important;
}
thead tr th:nth-child(-n + 2) {
  @apply border-r-0;
}
</style>
